import { useCampaignContext } from 'modules/campaigns/editor/context';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { AiSparkle16, Analytics } from 'ui/icons';

export const ViewAnalyticsAction = () => {
  const {
    campaign: { id },
    nbaEnabledCampaignIds,
  } = useCampaignContext();
  const isCampaignNBAEnabled = nbaEnabledCampaignIds?.includes(id);

  const navigate = useNavigate();

  const handleNav = useCallback(
    () => navigate(`/analytics/campaignPerformance?campaignId=${id}`),
    [id],
  );

  return (
    <SecondaryButton
      data-test="view-analytics-button"
      size={BUTTON_SIZES.LARGE}
      onClick={handleNav}
    >
      <Analytics />
      View analytics
      {isCampaignNBAEnabled && <AiSparkle16 data-test={`nba_enabled_${id}`} />}
    </SecondaryButton>
  );
};
